
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/profile-register",
      function () {
        return require("private-next-pages/register/profile-register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/profile-register"])
      });
    }
  